import { httpClient } from "@services/api/httpClient";

const verifyOfferApplicantEmail = async (offerId: number, email: string, code: string) => {
    const response = await httpClient.post("/offer-applicant/verify-email", {
        offerId,
        email,
        code,
    });
    return response.data;
};

export default verifyOfferApplicantEmail;
